import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Phone } from 'lucide-react';
import { Button } from '../ui/button';

export const LandingNav = ({ onDemo }) => (
  <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-bone/70 border-b border-forest-900/5" data-testid="landing-nav">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between">
      <a href="#top" className="flex items-center gap-2.5" data-testid="landing-logo">
        <span className="w-9 h-9 rounded-xl bg-forest-900 flex items-center justify-center">
          <Clock className="w-4.5 h-4.5 w-5 h-5 text-bone" />
        </span>
        <span className="font-display font-bold text-forest-900 text-lg tracking-tight">GestionaEmpleados</span>
      </a>
      <nav className="hidden md:flex items-center gap-6 lg:gap-8 font-body-landing text-sm font-medium text-forest-700">
        <a href="#funcionalidades" className="hover:text-forest-900 transition-colors" data-testid="nav-funcionalidades">Funcionalidades</a>
        <a href="#precios" className="hover:text-forest-900 transition-colors" data-testid="nav-precios">Precios</a>
        <a href="#comparativa" className="hover:text-forest-900 transition-colors" data-testid="nav-comparativa">Comparativa</a>
        <a href="#faq" className="hover:text-forest-900 transition-colors" data-testid="nav-faq">Preguntas</a>
        <Link to="/admin/login" className="hover:text-forest-900 transition-colors" data-testid="nav-login">Acceso clientes</Link>
      </nav>
      <div className="flex items-center gap-2 sm:gap-3">
        <a href="tel:+34680292427" className="hidden lg:inline-flex items-center gap-1.5 text-forest-900 font-body-landing font-bold text-sm hover:text-terracotta transition-colors" data-testid="nav-phone">
          <Phone className="w-4 h-4 text-terracotta" /> 680 292 427
        </a>
        <Button variant="outline" onClick={onDemo} className="rounded-full border-forest-900/20 text-forest-900 hover:bg-forest-100 font-body-landing font-semibold h-10 px-4 sm:px-6 bg-transparent" data-testid="nav-demo-btn">
          Ver demo
        </Button>
        <Button asChild className="rounded-full bg-terracotta hover:bg-terracotta-hover text-white font-body-landing font-bold h-10 px-4 sm:px-6">
          <Link to="/registro" data-testid="nav-trial-btn">Prueba gratis</Link>
        </Button>
      </div>
    </div>
  </header>
);
